import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 px-4" data-id="element-46">
      <div className="max-w-[900px] mx-auto" data-id="element-47">
        <div className="bg-gradient-to-br from-[#00ff88]/10 to-[#00d4ff]/5 border-[3px] border-[#00ff88] rounded-xl p-8 md:p-12 text-center shadow-[0_0_40px_rgba(0,255,136,0.1)]" data-id="element-48">
          <div className="w-20 h-20 bg-[#00ff88]/20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-49">
            <ShieldCheck className="w-10 h-10 text-[#00ff88]" data-id="element-50" />
          </div>

          <h2 className="text-xl md:text-[1.3rem] font-bold text-[#00ff88] mb-6 uppercase tracking-wide" data-id="element-51">
            GARANTÍA DE 30 DÍAS 100% REEMBOLSABLE
          </h2>

          <p className="text-[1.05rem] text-[#e0e0e0] leading-relaxed mb-4" data-id="element-52">
            Si en los próximos 30 días comprobás que esto no vale cada peso que
            pagaste, te devolvemos TODO. Sin preguntas, sin excusas. Tu riesgo
            es CERO.
          </p>

          <p className="text-[1.05rem] font-bold text-[#00d4ff]" data-id="element-53">
            Pero sabemos que sí va a valer.
          </p>
        </div>
      </div>
    </section>;
}